import { Transport } from './transport/xhrTransport'
import config from '@/config'

class InstanceConfigQuery extends Transport {
  constructor() {
    super({
      origin: `${config.scriptspath}/`,
      apiMethod: `${config.instance}.json`
    })
  }
}

export default InstanceConfigQuery
